import React, { useState, useEffect } from 'react';

import { getDevice } from '@common/Util';

const withDeviceType = (WrappedComponent) => {
  return function WithDeviceTypeComponent(props) {
    const [deviceType, setDeviceType] = useState(getDevice(window.innerWidth));

    function handleResize() {
      const width = window.innerWidth;
      const newDeviceType = getDevice(width);
      setDeviceType(newDeviceType);
    }

    useEffect(() => {
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    return <WrappedComponent {...props} deviceType={deviceType} />;
  };
};

export default withDeviceType;
